import React, { useRef } from 'react';
import { IInputPhoneProps } from './input-phone-form-item.types';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import '../input-phone.scss';
import { Form, Input } from 'antd';

const InputPhoneFormItem = ({
  onBlur,
  disabled,
  numberFieldName,
  countryCodeFieldName,
  label,
  initCountryCode,
  initPhoneNumner,
  placeholder = 'Enter phone number',
}: IInputPhoneProps) => {
  const form = Form.useFormInstance();
  const divRef = useRef<any>();

  let initValue;

  if (initCountryCode && initPhoneNumner) {
    initValue = initCountryCode + initPhoneNumner;
    form.setFieldValue(countryCodeFieldName, initCountryCode);
    form.setFieldValue(numberFieldName, initPhoneNumner);
  } else {
    const code = form.getFieldValue(countryCodeFieldName) ?? '+1';
    const number = form.getFieldValue(numberFieldName);

    initValue = !code && !number ? '' : `${code}${number}`;
  }

  const handleChange = (value: string, data: CountryData, event: any, formattedValue: string) => {
    if (!value || value === '') {
      form.setFieldValue(countryCodeFieldName, '');
      form.setFieldValue(numberFieldName, '');
      return;
    }

    const code = `+${data.dialCode}`;
    const number = value.replace(data.dialCode, '');

    form.setFieldValue(countryCodeFieldName, code);
    form.setFieldValue(numberFieldName, number);

    if (divRef.current) {
      const el = divRef.current.querySelector('.eiq-phone-number-input');
      if (el && el.value.length <= 2) {
        let len = el.value.length + 1;
        el.setSelectionRange(len, len);
        el.focus();
      }
    }
  };

  return (
    <>
      <Form.Item name={countryCodeFieldName} hidden>
        <Input />
      </Form.Item>
      <Form.Item name={numberFieldName} hidden>
        <Input />
      </Form.Item>
      <Form.Item label={label} style={{ flex: '1' }} name={'fullPhoneNumber'}>
        <div ref={divRef}>
          <PhoneInput
            preferredCountries={['us', 'ca', 'mx']}
            country={'us'}
            placeholder={placeholder}
            value={initValue}
            onChange={handleChange}
            onBlur={onBlur}
            disabled={disabled}
            containerClass="eiq-phone-number"
            inputClass="eiq-phone-number-input"
          />
        </div>
      </Form.Item>
    </>
  );
};

export default InputPhoneFormItem;
